import Vue from "vue";
import Vuex from "vuex";
import { GLOBAL } from "@/config/consts";
import { instanceAxios } from "@/plugins/axios";
import modules from "./modules";

Vuex.Store.prototype.$axios = instanceAxios;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token"),
    refresh_token: localStorage.getItem("refresh_token"),
    user: JSON.parse(localStorage.getItem("user"))
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
    },
    set_user(state, user) {
      localStorage.setItem("user", JSON.stringify(user));
      state.user = user;
    }
  },
  actions: {
    async login({ commit }, user) {
      commit("auth_request");

      try {
        const { data } = await this.$axios.post(GLOBAL.apiUrl.login, user);
        const token = data.token;

        localStorage.setItem("token", token);
        localStorage.setItem("refresh_token", data["refresh_token"]);
        this.$axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${token}`;
        commit("auth_success", token);
      } catch (e) {
        console.log(e);
        commit("auth_error");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
      }
    },
    async logout({ commit }) {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      delete this.$axios.defaults.headers.common["Authorization"];
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    user: state => state.user,
    isAdmin: state =>
      state.user && state.user.roles && state.user.roles.includes("ROLE_ADMIN"),
    isDeveloper: state =>
      state.user &&
      state.user.roles &&
      state.user.roles.includes("ROLE_DEVELOPER"),
    getErrorText: () => response => {
      if (response && response.data && response.data.detail) {
        return response.data.detail;
      }
      return GLOBAL.defaultErrorText;
    }
  },
  setters: {},
  modules: {
    ...modules
  }
});
